import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const ThreeDotZeroDotOne = () => {
  return (
    <ChangelogInstance version="3.0.1" date="2023-12-29">
      <li>
        Removed "scripting" permission per the requirements of the Chrome Web Store.
      </li>
    </ChangelogInstance>
  );
}

export default ThreeDotZeroDotOne;